export default function EmailIcon({ className }) {
    return (
      <svg className={className} width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28 0C12.53 0 0 12.53 0 28C0 43.47 12.53 56 28 56C43.47 56 56 43.47 56 28C56 12.53 43.47 0 28 0ZM42 38.78H14V20.748L25.438 29.554C26.166 30.114 27.076 30.422 28 30.422C28.924 30.422 29.834 30.114 30.562 29.554L42 20.748V38.78ZM28.854 27.342C28.35 27.734 27.65 27.734 27.146 27.342L14 17.22H42L28.854 27.342Z"
              fill="#203B3F" />
      </svg>
    )
}
